import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { CockpitProposal } from './cockpitBackend';
import { CockpitSources } from './CockpitSources';

/**
 * What both assistant views (drawer and page) show in a conversation: the
 * cockpit's example questions and texts (formal German, unlike the shared
 * defaults), and the documentation sources under every answer.
 */
export function useCockpitConversation() {
  const { t } = useTranslation();
  return useMemo(
    () => ({
      prompts: [t('cockpit.suggestion1'), t('cockpit.suggestion2'), t('cockpit.suggestion3')],
      emptyText: t('cockpit.emptyDescription'),
      placeholder: t('cockpit.placeholder'),
      renderProposals: (proposals: CockpitProposal[]) => <CockpitSources proposals={proposals} />,
    }),
    [t],
  );
}
